/**
 * App login accounts (email + PIN) — role / driver metadata fallback.
 * Auth is Appwrite sessions; password = PIN + PIN (see authService.pinToPassword).
 * Provision Auth users with: npm run setup:auth-users
 */
export const AUTH_USERS = [
  {
    email: 'joram.kalugira@sagemcom.com',
    pin: '1407',
    name: 'Joram Kalugira',
    role: 'admin'
  },
  {
    email: 'kelvin.manaseh@sagemcom.com',
    pin: '2028',
    name: 'Kelvin Manaseh',
    role: 'admin'
  },
  {
    email: 'admin@sagemcom.local',
    pin: '1234',
    name: 'Fleet Admin',
    role: 'admin'
  },
  {
    email: 'geoffrey.mwangi@sagemcom.com',
    pin: '1313',
    name: 'MWANGI Geoffrey',
    role: 'driver',
    driverKey: 'geoffrey',
    polesLot10: true,
    toolsAccess: true
  },
  {
    email: 'shadrack.kipruto@sagemcom.com',
    pin: '9090',
    name: 'KIPRUTO Shadrack',
    role: 'driver',
    driverKey: 'kipruto',
    polesLot10: true,
    toolsAccess: true
  },
  {
    email: 'philipo.mwakibete@sagemcom.com',
    pin: '2020',
    name: 'MWAKIBETE Philipo',
    role: 'driver',
    driverKey: 'philipo'
  },
  {
    email: 'davis.mlay@sagemcom.com',
    pin: '1212',
    name: 'MLAY Davis',
    role: 'driver',
    driverKey: 'mlay'
  },
  {
    email: 'mayur.shir@sagemcom.com',
    pin: '1122',
    name: 'Mayur',
    role: 'admin'
  },
  {
    email: 'kennedy.munisi@sagemcom.com',
    pin: '4433',
    name: 'Kennedy Munisi',
    role: 'driver',
    driverKey: 'kennedy'
  },
  {
    email: 'onesmo.deogratius@sagemcom.com',
    pin: '9028',
    name: 'DEOGRATIUS Onesmo',
    role: 'driver',
    driverKey: 'onesmo'
  },
  {
    email: 'festo.samson@sagemcom.com',
    pin: '5518',
    name: 'Festo Samson',
    role: 'driver',
    driverKey: 'festo'
  },
  {
    email: 'cromwell-oronje.onyango@sagemcom.com',
    pin: '0098',
    name: 'Cromwell Onyango',
    role: 'driver',
    driverKey: 'cromwell',
    polesLot10: true,
    toolsAccess: true
  },
  {
    email: 'bakari.mtwanga@sagemcom.com',
    pin: '9701',
    name: 'Bakari Mtwange',
    role: 'driver',
    driverKey: 'bakari'
  },
  {
    email: 'petro.nziya@sagemcom.com',
    pin: '2987',
    name: 'Petro Nziya',
    role: 'driver',
    driverKey: 'petro'
  },
  {
    email: 'patrick.muriuki@sagemcom.com',
    pin: '7409',
    name: 'MURIUKI Patrick',
    role: 'admin'
  },
  {
    email: 'colin.kuteesa@sagemcom.com',
    pin: '8877',
    name: 'KUTEESA Colin',
    role: 'admin'
  },
  {
    email: 'cheikhou-el-hadji.thior@sagemcom.com',
    pin: '0099',
    name: 'THIOR Elhadji',
    role: 'driver',
    driverKey: 'thior'
  }
];
